import React from 'react';
import './CampoObrigatorio.css';

const CampoObrigatorio = () => {
    return (
        <span className="campo-obrigatorio">*</span>
    );
}
 
export default CampoObrigatorio;